import { render } from "./Swap.vue?vue&type=template&id=deb6f204"
import script from "./Swap.vue?vue&type=script&setup=true&lang=js"
export * from "./Swap.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/Swap.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "deb6f204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('deb6f204', __exports__)) {
    api.reload('deb6f204', __exports__)
  }
  
  module.hot.accept("./Swap.vue?vue&type=template&id=deb6f204", () => {
    api.rerender('deb6f204', render)
  })

}


export default __exports__